const ImageCache = require("../../util/ImageCache");
const AssetsUtil = require("../../util/AssetsUtil");

const botImageNode = {
	draw(rc, x, y, node, measure) {
		const context = rc.context;
		const {width, top, bottom, childrenMeasures, fontInfo} = measure;
		const {name} = node;
		const imageSrc = ImageCache.src(AssetsUtil.getBotImage(name));
		context.save();
		context.drawImage(imageSrc, x, y - top, width, top + bottom);
		context.restore();
		const {children = []} = node;
		children.forEach((child, i) => {
			const m = childrenMeasures[i];
			const offsetX = (node.offsetX || 0) * fontInfo.size;
			const offsetY = (node.offsetY || 0) * fontInfo.size;
			rc.drawNode(
				rc,
				x + 0.5 * width - 0.5 * m.width + offsetX || 0,
				y + offsetY || 0,
				child,
				m
			);
		});
	},

	measure(rc, fontInfo, props, node) {
		const scale = node.scale || 1;
		const aspectRatio = node.aspectRatio || {
			w: 1,
			h: 1,
		};
		const baseSize = fontInfo.size * 2.5 * scale;

		const width = baseSize;
		const height = (width * aspectRatio.h) / aspectRatio.w;
		const children = node.children || [];
		const childrenMeasures = children.map(n =>
			rc.measureNode(rc, fontInfo, props, n)
		);
		return {
			width,
			top: height / 2,
			bottom: height / 2,
			fontInfo,
			childrenMeasures,
		};
	},

	readAloud: "",
};

module.exports = {
	parsers: {
		mathCommands: {},
	},
	nodes: {
		botImage: botImageNode,
	},
};
